import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import ScrollableContent from '../ScrollableContent';
var StreamableList = /** @class */ (function (_super) {
    tslib_1.__extends(StreamableList, _super);
    function StreamableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isScrolled: false,
            isScrolledToBottom: false,
        };
        _this.initialFetch = function () {
            var _a = _this.props, isEmpty = _a.isEmpty, isFetching = _a.isFetching, hasMore = _a.hasMore, fetchMore = _a.fetchMore, streamId = _a.streamId;
            if (!isFetching && hasMore && isEmpty) {
                fetchMore(streamId);
            }
        };
        _this.onListScroll = function (scrollTop, distanceToBottom) {
            var _a = _this.props, isFetching = _a.isFetching, hasError = _a.hasError, hasMore = _a.hasMore, fetchMore = _a.fetchMore, streamId = _a.streamId, onScrolled = _a.onScrolled, _b = _a.loadMoreDistance, loadMoreDistance = _b === void 0 ? 80 : _b;
            var _c = _this.state, isScrolled = _c.isScrolled, isScrolledToBottom = _c.isScrolledToBottom;
            if (distanceToBottom < loadMoreDistance &&
                !isFetching &&
                !hasError &&
                hasMore) {
                fetchMore(streamId);
            }
            var isScrolledNew = scrollTop !== 0;
            var isScrolledBottomNew = distanceToBottom < 1;
            if (isScrolled !== isScrolledNew ||
                isScrolledToBottom !== isScrolledBottomNew) {
                // let's only update state when something actually changed because things can get laggy
                _this.setState({
                    isScrolled: isScrolledNew,
                    isScrolledToBottom: isScrolledBottomNew,
                });
            }
            onScrolled && onScrolled(scrollTop, distanceToBottom);
        };
        return _this;
    }
    StreamableList.prototype.componentDidMount = function () {
        this.initialFetch();
    };
    StreamableList.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.streamId !== this.props.streamId) {
            this.initialFetch();
        }
    };
    StreamableList.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, wrapperClassName = _a.wrapperClassName, scrolledClassName = _a.scrolledClassName, bottomedClassName = _a.bottomedClassName, _b = _a.throttleTimeout, throttleTimeout = _b === void 0 ? 300 : _b;
        var _c = this.state, isScrolled = _c.isScrolled, isScrolledToBottom = _c.isScrolledToBottom;
        return (React.createElement(ScrollableContent, { className: className, throttleTimeout: throttleTimeout, onScrolled: this.onListScroll, wrapperClassName: classnames(wrapperClassName, isScrolled && scrolledClassName, isScrolledToBottom && bottomedClassName) }, children));
    };
    return StreamableList;
}(React.Component));
export { StreamableList };
export default StreamableList;
//# sourceMappingURL=StreamedList.js.map